import ApplicationController from './application_controller'
import Masonry from "masonry-layout"

export default class extends ApplicationController {

	connect() {
		this.config = { "percentPosition": true }
		this.masonry = new Masonry(this.element, this.config)
	}	

	disconnect() {
		this.masonry.destroy()
	}

}
